module.exports = __webpack_public_path__ + "img/label_pink.43d02315.png";